import i18n from '@plugins/i18n';

import { Collection, VisibilityGroup } from '@/models';

export class VisibilityGroupsCollection extends Collection {
    static type = 'VisibilityGroupsCollection';
    static endpoint = VisibilityGroup.api.index;
    static model = VisibilityGroup;

    static fields() {
        return {
            ...super.fields(),
            adviser_id: this.string(null).nullable(),
            exclude_ids: this.string(null).nullable()
        };
    }

    get preset_filters() {
        let filters = {};

        if (this.adviser_id) {
            filters.adviser_id = this.filterOperator('is') + ':' + this.adviser_id;
        }

        return filters;
    }

    transformFilters(filters = {}) {
        if (this.exclude_ids) {
            filters.id = this.filterOperator('not_in') + ':' + this.exclude_ids;
        }

        return filters;
    }

    get headers() {
        return [
            this.createHeader('name', i18n.t('group_name'), {
                width: '18rem',
                minWidth: '18rem',
                filterable: true,
                sortable: true
            })
        ];
    }

    get default_headers() {
        return ['name'];
    }
}

export default VisibilityGroupsCollection;
